import React from "react";
import LoadingImg from "../assets/loading1.png";

const LoadingPage = () => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-[#020617]">
      <div className="flex flex-col items-center">
        {/* Controller Pulse Animation */}
        <div className="relative flex items-center justify-center">
          <img
            src={LoadingImg}
            alt="Game Loading"
            className="w-28 h-28 animate-controller-pulse rounded-full"
          />
        </div>

        <p className="text-white/70 mt-6 text-sm tracking-widest animate-pulse">
          Habesha 21 Bingo...
        </p>
      </div>
    </div>
  );
};

export default LoadingPage;
